const floatPattern = /^-{0,1}[0-9]{0,}[.,][0-9]{1,}$/;
const integerPattern = /^[0-9]{1,}$/;

export function checkIfCloseToZero(value) {
    if (Math.abs(value) < 1.e-2) return 0
    return value
}

export function isAccountingZero(value) {
    const lValue = Math.round( value * 100)/100
    if (Math.abs(lValue)) {
        return false
    }
    return true
}

export function newCommonFormatCurrency(
    value,
    options: any = undefined
) {
    options = {
        ...{
            dashForZero: true,
            currency: 'EUR', // ** to hide currency symbol, please set currency to ''
            decimals: 2,
            appendCharacter: undefined, //** ex "%"
            DC: false // ** to display "D" or "C" at the end of the amount
        }, ...options
    }

    if (
        value === undefined ||
        value === null ||
        value === 0 ||
        Math.abs(value) < 1.e-2
    ) {
        return options.dashForZero ? "-" : ""
    }

    let amountOptions: Intl.NumberFormatOptions = {
        minimumFractionDigits: options.decimals,
        maximumFractionDigits: options.decimals,
    }

    if (options.currency?.length && !options.appendCharacter && !options.DC) {
        amountOptions.style = 'currency'
        amountOptions.currency = options.currency
    }

    let lValue = Math.round(value * 100) / 100
    let debitOrCredit = ""
    if (options.DC) {
        if (lValue > 0) {
            debitOrCredit = " D"
        } else {
            debitOrCredit = " C"
        }
        lValue = Math.abs(lValue)
    }
    let formattedValue = new Intl.NumberFormat('fr-FR', amountOptions).format(lValue)

    if (options.appendCharacter) {
        formattedValue += " " + options.appendCharacter
    }

    if (options.DC) {
        formattedValue += debitOrCredit
    }

    return formattedValue
}

export function formatCurrency(value, dashForZero:boolean=false, currency:string = 'EUR') {
    if (value === undefined || value === null) return dashForZero ? "-" : "";
    let lValue = Math.round(value*100)/100
    if (dashForZero && Math.abs(lValue) < 1.e-2) {
        return "-"
    }

    let options:any = {}

    if (currency) {
        options.style = 'currency'
        options.currency = currency
    }

    return new Intl.NumberFormat('fr-FR', options).format(lValue);
}

export function formatCurrency2(value, dashForZero: boolean = false, currency: string = 'EUR', decimals: number = 2, hideCurrencySymbol: boolean = true, appendCharacter: string = "") {
    if (value === undefined || value === null) return dashForZero ? "-" : "";
    let lValue = Math.round(value*100)/100
    if (value === 0 || (dashForZero && Math.abs(lValue) < 1.e-2)) {
        return "-"
    }

    // ** currencyDisplay : "symbol" | "code"
    // ** "symbol": use a localized currency symbol such as "€".
    // ** "code": use the ISO currency code such as "EUR".
    let options: any = {
        style: 'currency',
        currency: currency || 'EUR',
        // currencyDisplay: 'symbol', // ** to be sure to have the correct length: "EUR" instead of "€"
        minimumFractionDigits: decimals,
        roundingMode: "halfEven"
    }

    // ** formattedValue = "1 234,56 €"
    const formattedValue = new Intl.NumberFormat('fr-FR', options).format(lValue)

    let formattedValueWithoutSymbol = formattedValue
    if (hideCurrencySymbol) {
        // ** remove currency symbol " €"
        let symbolLength: number = 2 // ** " €"
        formattedValueWithoutSymbol = formattedValue.slice(0, formattedValue.length - symbolLength)
    }

    if (appendCharacter) {
        formattedValueWithoutSymbol += appendCharacter
    }

    // ** formattedValueWithoutSymbol = "1 234,56"
    return formattedValueWithoutSymbol
}

export function formatCurrencyWithoutDecimals(value, dashForZero:boolean=false, currency:string = 'EUR') {
    if (value === undefined || value === null) return dashForZero ? "-" : "";
    let lValue = Math.round(value*100)/100
    if (dashForZero && Math.abs(lValue) < 1.e-2) {
        return "-"
    }
    let options:any = {
        minimumFractionDigits: 0
    }

    if (currency) {
        options.style = 'currency'
        options.currency = currency
    }

    return new Intl.NumberFormat('fr-FR', options).format(lValue);
}

export function formatCurrencyDC(value, dashForZero: boolean = false, currency: string = 'EUR', decimals: number = 2) {
    const formattedValueWithoutSymbol = formatCurrency2(value, dashForZero, currency, decimals)

    if (value > 0) {
        return formattedValueWithoutSymbol + " D";
    } else if (value < 0) {
        return formattedValueWithoutSymbol.replace('-', '') + " C";
    } else {
        return '-'
    }
}

export function checkInt(x) {
    if (x === undefined || x === "") {
        debugger;
        return false;
    }
    return !!x.match(integerPattern);
}

export function checkFloat(x) {
    if (x === undefined || x === "") {
        debugger;
        return 0;
    }
    return !!x.match(floatPattern)
}

export function checkAmount(x) {
    let result = checkFloat(x);
    if (!result) result = checkInt(x);
    return result;
}

export function mathFix(value:number, dec:number = 2) {
    if (dec >= 0) {
        const r = Math.pow(10, dec);
        return (value >= 0 ? 1 : -1) * Math.round(Math.abs(value) * r) / r;
    }
    debugger;
    return value;
}

export function convertBigInts(rows, att:string="count") {
    for (const row of rows) {
        row[att] = Number(row[att])
    }
}
